var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswerPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48438 5.43359L10.5781 8.05859C10.7695 8.49609 10.6602 9.01562 10.2773 9.31641L8.9375 10.4375C9.83984 12.3516 11.3984 13.9102 13.3125 14.8125L14.4336 13.4727C14.7344 13.0898 15.2539 12.9805 15.6914 13.1719L18.3164 14.2656C18.8359 14.457 19.082 15.0312 18.9453 15.5508L18.2891 17.957C18.1523 18.4219 17.7422 18.75 17.25 18.75C10.4688 18.75 5 13.2812 5 6.5C5 6.00781 5.32812 5.59766 5.79297 5.46094L8.19922 4.80469C8.71875 4.66797 9.29297 4.91406 9.48438 5.43359Z",
    fill: "#C1F553"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerPhone);
export default __webpack_public_path__ + "static/media/answer-phone.6532f6b36aef3ee3522c78e6fd805b99.svg";
export { ForwardRef as ReactComponent };